export default __webpack_public_path__ + "static/uniswap-0e5730eb38c638e1a78e1c8545ffd46c.png";